module.exports = __webpack_public_path__ + "static/media/team_1.db85fff2.png";